import React from 'react';
import styles from './Hero.module.css';

interface HeroProps {
  heading: string;
  subheading?: string;
  backgroundImage?: string;
  primaryButtonText?: string;
  primaryButtonLink?: string;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
}

export const Hero: React.FC<HeroProps> = ({
  heading,
  subheading,
  backgroundImage,
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
}) => {
  const style = backgroundImage
    ? { backgroundImage: `url(${backgroundImage})` }
    : undefined;

  return (
    <div className={styles.hero} style={style}>
      <div className={styles.overlay}>
        <div className={styles.content}>
          <h1 className={styles.heading}>{heading}</h1>
          {subheading && <p className={styles.subheading}>{subheading}</p>}
          {(primaryButtonText || secondaryButtonText) && (
            <div className={styles.buttons}>
              {primaryButtonText && primaryButtonLink && (
                <a href={primaryButtonLink} className={styles.primaryButton}>
                  {primaryButtonText}
                </a>
              )}
              {secondaryButtonText && secondaryButtonLink && (
                <a href={secondaryButtonLink} className={styles.secondaryButton}>
                  {secondaryButtonText}
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
